<template>
    <div>
        <base-modal ref="loginModal" header-disable footer-disable>
            <template v-slot:body>
                <div class="samo samo-site">
                    <div class="login-form">
                        <div class="form-header">
                            <h1 class="login-modal_title">{{ $t('app.modals.login.title') }}</h1>
                        </div>
                        <div class="form-group">
                            <label class="control-label samo-label" for="login">{{
                                getTranslateSpace($t('app.modals.login.login_label')) }}</label>
                            <input id="login" class="samo-input form-control"
                                :class="{ 'is-invalid': v$.user.login.$error }" v-model="user.login" type="text">
                            <small class="error-message" v-if="v$.user.login.$error">{{
                                $t(...getTranslateParams(v$.user.login.$errors[0].$message)) }}</small>
                        </div>
                        <div class="form-group">
                            <label class="control-label samo-label" for="password">{{
                                getTranslateSpace($t('app.modals.login.password_label')) }}</label>
                            <input id="password" class="samo-input form-control"
                                :class="{ 'is-invalid': v$.user.password.$error }" v-model="user.password"
                                type="password">
                            <small class="error-message" v-if="v$.user.password.$error">{{
                                $t(...getTranslateParams(v$.user.password.$errors[0].$message)) }}</small>
                        </div>
                        <div class="form-group">
                            <div class="_loginError" style="display:none;color:red;">{{ $t('app.login_error') }}</div>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary text-white" @click="login">{{ $t('app.login') }}</button>
                        </div>
                        <div class="form-group text-center">
                            <a class="btn-link" href="#" @click="openSignup">{{ $t('app.signup') }}</a><br>
                            <a class="btn-link" href="#" @click="openRestorePwd">{{ $t('app.forgot_password') }}</a>
                        </div>
                        
                        <div class="error mt-4 p-3" v-if="error">
                            {{ error }}
                        </div>

                        <div v-if="infoMessage" class="mt-4 p-3 info-message row g-0">
                            {{ infoMessage }}
                        </div>

                        <div class="mt-4 p-3 demo-access info-message row g-0" v-if="config?.main?.show_demo_access">
                            <div class="text-start col-md-6" @click="setDemoAccess('samo', '1234')">
                                <div><strong class="mb-1">Организация:</strong></div>
                                <div class="mb-1"><strong>{{ $t('app.modals.login.login_label') }}: </strong>samo</div>
                                <div><strong>{{ $t('app.modals.login.password_label') }}: </strong>1234</div>
                            </div>
                            <div class="text-start col-md-6" @click="setDemoAccess('phys@fakeland.ru', '1234')">
                                <div><strong class="mb-1">Физическое лицо:</strong></div>
                                <div class="mb-1"><strong>{{ $t('app.modals.login.login_label') }}:
                                    </strong>phys@fakeland.ru</div>
                                <div><strong>{{ $t('app.modals.login.password_label') }}: </strong>1234</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </base-modal>
        <register-modal ref="registerModal" @open-login="openLoginModal" />
        <restore-modal ref="restorePwdModal" @open-login="openLoginModal" />
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
import BaseModal from 'components/ui/BaseModal.vue'
import RegisterModal from 'modules/login/RegisterModal.vue'
import RestoreModal from 'modules/login/RestoreModal.vue'
import { mapState } from "vuex"
import translateMixin from 'mixins/translate'

export default {
    name: "LoginModal",
    components: { BaseModal, RegisterModal, RestoreModal },
    mixins: [translateMixin],
    setup() {
        return { v$: useVuelidate() }
    },
    data() {
        return {
            user: { login: '', password: '' },
            isLoading: false,
            error: null,
            infoMessage: null
        }
    },
    validations: {
        user: {
            login: { required },
            password: { required, minLength: minLength(4) }
        }
    },
    computed: {
        ...mapState({ 
            locale: state => state.locale,
            config: state => state.config,
        })
    },
    methods: {
        setDemoAccess(login, password) {
            this.user.login = login;
            this.user.password = password;
        },
        openLoginModal() {
            this.$refs.registerModal.$refs.modal.close();
            this.$refs.restorePwdModal.$refs.restoreModal.close();
            this.$refs.loginModal.open();
        },
        open() {
            this.$refs.loginModal.open();
        },
        openSignup() {
            this.$refs.loginModal.close();
            this.$refs.registerModal.open();
        },
        openRestorePwd() {
            this.$refs.loginModal.close();
            this.$refs.restorePwdModal.open();
        },
        login() {
            this.v$.user.$touch();
            this.error = null;
            if (!this.v$.user.$invalid) {
                const formData = { login: this.user.login, password: this.user.password, login_type: 1 };
                this.$store.dispatch('users/login', { credentials: formData, router: this.$router }).then(() => {
                    this.user = { login: '', password: '' };
                    this.$refs.loginModal.close();
                }).catch((error) => {
                    this.user = { login: '', password: '' };
                    switch(error.data.code){
                        case -3:
                            this.error = this.$root.$t('app.modals.login.account_is_not_activated');
                            break;
                        default:
                            this.error = error.data.message
                    }
                });
            }
        }
    }
}
</script>

<style>
.info-message {
    border: 1px solid var(--bs-primary);
    background: #c4e2ff;
    border-radius: 4px;
    color: var(--bs-black);
}
.error {
    border: 1px solid var(--bs-danger);
    background: #ffd4d4;
    border-radius: 4px;
    color: var(--bs-danger);
}
.demo-access > div{
    cursor: pointer;
}
</style>
